import { render, staticRenderFns } from "./zhuanxiang.vue?vue&type=template&id=e9fe910c&scoped=true&"
import script from "./zhuanxiang.vue?vue&type=script&lang=js&"
export * from "./zhuanxiang.vue?vue&type=script&lang=js&"
import style0 from "./zhuanxiang.vue?vue&type=style&index=0&id=e9fe910c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fe910c",
  null
  
)

export default component.exports